import { TableContainer, Card, CardContent, Stack, Typography, Avatar, IconButton } from '@mui/material';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import Paper from '@mui/material/Paper';

const CardDetails = ({ title, diff, trend, sx, value, viewLogs }) => {
   
    const TrendIcon = trend === 'up' ? null : null;
    const trendColor = trend === 'up' ? 'var(--mui-palette-success-main)' : 'var(--mui-palette-error-main)';
  
    return (
      <TableContainer component={Paper}>
        <Card sx={{ boxShadow: 'none', ...sx }} elevation={0}>
            <CardContent>
            <Stack spacing={3}>
                <Stack direction="row" sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }} spacing={3}>
                <Stack spacing={1}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                  <Typography
                    color="text.secondary"
                    variant="overline"
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {title}
                  </Typography>
                  {typeof viewLogs === 'function' && (
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={viewLogs}
                      aria-label="View Logs"
                    >
                      <RemoveRedEyeOutlinedIcon fontSize="small" />
                    </IconButton>
                  )}
                </Stack>
                <Typography variant="h4">{value}</Typography>
                </Stack>
                <Avatar sx={{ backgroundColor: 'var(--mui-palette-primary-main)', height: '56px', width: '56px' }}>
                    <RemoveRedEyeOutlinedIcon  />
                </Avatar>
                </Stack>
                {diff ? (
                <Stack sx={{ alignItems: 'center' }} direction="row" spacing={2}>
                    <Stack sx={{ alignItems: 'center' }} direction="row" spacing={0.5}>
                    <TrendIcon color={trendColor} fontSize="var(--icon-fontSize-md)" />
                    <Typography color={trendColor} variant="body2">
                        {diff}%
                    </Typography>
                    </Stack>
                    <Typography color="text.secondary" variant="caption">
                    Since last month
                    </Typography>
                </Stack>
                ) : null}
            </Stack>
            </CardContent>
        </Card>
      </TableContainer>
    );
  }

export default CardDetails;